import { ProductConstants, ShowProductType } from "@@types/IProduct";
import { useFetchProductById } from "@queries/products";
import { UseQueryResult } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { createContext, ReactNode, useState } from "react";

export interface ProductTabsContextData {
  productUuid: string;
  courseUuid?: string;
  product?: ShowProductType;
  productQuery: UseQueryResult<ShowProductType, unknown>;
  viewType: string;
  isProductError: boolean;
  setViewType: (value: "list" | "create" | "update") => void;
  noContents: boolean;
  currentTab: string;
  setCurrentTab: (value: string) => void;
}
interface ProductTabsProviderProps {
  children: ReactNode;
}

export const ProductContext = createContext({} as ProductTabsContextData);

export function ProductTabsProvider({ children }: ProductTabsProviderProps) {
  const [noContents, setNoContents] = useState(false);
  const [currentTab, setCurrentTab] = useState("");
  const [viewType, setViewType] = useState<"list" | "create" | "update">("list");

  const router = useRouter();
  const productUuid = typeof router.query?.id === "string" ? router.query.id : "";

  const productQuery = useFetchProductById(productUuid);

  const { data: product, isError } = productQuery;

  const courseUuid = product?.courseUuid;

  const isProductError = isError;

  return (
    <ProductContext.Provider
      value={{
        courseUuid,
        productUuid,
        product,
        productQuery,
        viewType,
        setViewType,
        isProductError,
        noContents,
        currentTab,
        setCurrentTab,
      }}
    >
      {children}
    </ProductContext.Provider>
  );
}
